<template>
  <div>
    <div class="main">
      <Exit v-show="isVisible" @closePopUp="close" @showPopUp="show" />
      <section class="hero" v-scroll-reveal>
        <div class="container">
          <div class="description">
            <h1>Are you ready to fight for the treasure?</h1>
            <p>
              Welcome to
              <strong>Pets 'n' Pirates</strong>, a strategic treasure hunting card game with crazy pets, pirates and unexpected events that will help your quest or turn the tide.<br>
            </p>
            <p>The crowdfunding has been a success, and the game is <strong>now available online!</strong>            </p>
            <a
              class="button cta"
              href="https://www.amazon.co.uk/Pirates-Family-Party-Board-Childrens/dp/B09XV3176X/ref=sr_1_2"
              target="_blank"
            >Buy now on Amazon!</a>
          </div>
          <div class="hero-image">
            <img src="../../images/KeyVisual2.png" alt />
          </div>
        </div>
      </section>
      <section class="video" v-scroll-reveal>
        <div class="container">
          <h2>Find out more</h2>
          <div class="video-responsive">
            <youtube
              video-id="P0_NIbUniRg"
              player-width="960"
              player-height="540"
              :player-vars="{showinfo: 0, rel: 0, modestbranding: 1}"
              @playing="track('video_start', 'Video')"
              @ended="track('video_end', 'Video')"
            ></youtube>
          </div>
        </div>
      </section>
      <section class="carousel" v-scroll-reveal>
        <carousel
          :autoplay="false"
          :scrollPerPage="false"
          :autoplayTimeout="3000"
          :loop="true"
          :centerMode="true"
          :perPageCustom="[[320,1]]"
        >
          <slide>
            <img src="@/../images/howtop1-100.jpg" alt />
          </slide>
          <slide>
            <img src="@/../images/howtop2-100.jpg" alt />
          </slide>
          <slide>
            <img src="@/../images/howtop3-100.jpg" alt />
          </slide>
          <slide>
            <img src="@/../images/howtop4-100.jpg" alt />
          </slide>
          <slide>
            <img src="@/../images/howtop5-100.jpg" alt />
          </slide> 
        </carousel>
      </section>
      <section class="crew" v-scroll-reveal>
        <h2>Meet the crew</h2>
        <div class="container">
          <div class="column">
            <img src="../../images/crew_mario.png" alt />
            <div>
              <h3>Mario</h3>
              <p>Dad, Vfx compositor and board game lover who found that the most difficult client to please is his 7 years old daughter when it comes to design a card game.</p>
            </div>
          </div>
          <div class="column">
            <img src="../../images/crew_clara.png" alt />
            <div>
              <h3>Clara</h3>
              <p>Youngest game designer of the team (7 years old), passionate about science and fantasy worlds, loves playing card games from 7am (true story , unfortunately for dad).</p>
            </div>
          </div>
          <div class="column">
            <img src="../../images/crew_camillo.png" alt />
            <div>
              <h3>Camillo</h3>
              <p>Dad, Art Director and creative geek, loves succeeding at highly risky adventures with every kind of pitfall and twists. So, please, support this project!</p>
            </div>
          </div>
        </div>
      </section>
      <Subscribe v-scroll-reveal ecategory="Newsletter" id="subscribe">
        <h2 slot="header">Stay updated</h2>
        <p slot="content">
          <b>Subscribe</b> to our newsletter and <b>get updates</b> on this project.
        </p>
      </Subscribe>
    </div>
  </div>
</template>

<script>
import Subscribe from "@/components/Subscribe.vue";
import Exit from "@/components/Exit.vue";

export default {
  name: "Main",
  props: {
    msg: String,
  },
  data() {
    return {
      isVisible: false,
      dontBother: false,
    };
  },
  components: {
    Subscribe,
    Exit,
  },
  methods: {
    track(action, category) {
      console.log(action, category);
      this.$gtag.event(action, {
        eventCategory: category,
      });
      window.fbq("trackCustom", action);
      
    },
    show() {
      if (!this.dontBother) {
        this.isVisible = true;
      }
    },
    close() {
      this.isVisible = false;
      this.dontBother = true;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.main {
  position: relative;
  min-height: 100vh;
}

.hero {
  margin: 1rem 0;
  text-align: center;
  .container {
    display: flex;
    flex-direction: column;
    @media screen and (min-width: $tablet) {
      flex-direction: row;
      flex-wrap: wrap;
    }
    .description {
      p {
        order: 3;
        a {
          color: $blue;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      @media screen and (min-width: $desktop) {
        flex-basis: 40%;
        margin-top: 4rem;
        text-align: left;
        h1 {
          font-size: 4rem;
          line-height: 3.5rem;
        }
        .cta {
          margin-left: 0;
        }
      }
    }
    .cta {
      width: 18rem;
      height: calc(18rem * 70 / 360);
      display: block;
      background: url("../../images/button.svg") no-repeat;
      color: white;
      text-transform: uppercase;
      font-size: 2.5rem;
      text-decoration: none;
      text-align: center;
      line-height: calc(18rem * 70 / 360);
      margin: 1.5rem auto;
    }
    .hero-image {
      @media screen and (min-width: $desktop) {
        flex-basis: 60%;
      }
    }
    img {
      width: 100%;
      height: auto;
      transition: all 0.2s ease-out;
      &:hover {
        transform: scale(1.1) rotate(2deg);
      }
    }
  }
}

.video {
  text-align: center;
  margin-bottom: $margin;
  .video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
  }
  .video-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
}

.carousel {
  margin-top: 3rem;
  text-align: center;
  background: white;
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
  img {
    max-width: 100%;
    height: auto;
  }
}

.crew .container {
  display: flex;
  flex-direction: column;
  @media screen and (min-width: $tablet) {
    flex-direction: row;
    justify-content: space-around;
  }
  .column {
    display: flex;
    margin-bottom: 1rem;
    align-items: center;
    flex-direction: column;
    text-align: center;
    img {
      margin: 1rem;
      height: 120px;
      width: auto;
    }
    @media screen and (min-width: $tablet) {
      flex-basis: 30%;
    }
  }
}
</style>
